// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo-module--logo--1BHSa","text":"Logo-module--text--v6HDX"};